import { nanoid } from 'nanoid';

import { type ExtendToColumnEvent } from '../events/types';
import { type SelectionRange, type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function extendToColumnReducer(
  state: SelectionState,
  event: ExtendToColumnEvent
): ReducerResponse {
  const anchor = state.focusedCell ?? {
    row: { index: 0 },
    col: event.col
  };
  const lead = {
    row: anchor.row,
    col: event.col
  };

  if (state.mode === 'column' && state.selections.length === 1) {
    const existing = state.selections[0];
    const updatedSelection: SelectionRange = {
      ...existing,
      lead
    };

    return {
      delta: {
        kind: 'selectionModified',
        source: event.source,
        updated: [updatedSelection]
      },
      next: {
        ...state,
        selections: [updatedSelection],
        lastInteractionSource: event.source
      }
    };
  }

  const newSelection: SelectionRange = {
    id: nanoid(),
    anchor,
    lead
  };

  return {
    delta: {
      kind: 'selectionReplaced',
      source: event.source,
      selections: [newSelection],
      focusChange: state.focusedCell ? undefined : { prev: null, next: anchor }
    },
    next: {
      ...state,
      mode: 'column',
      focusedCell: state.focusedCell ?? anchor,
      selections: [newSelection],
      lastInteractionSource: event.source
    }
  };
}
